import React from 'react'
import { thunks as MarketThunks } from 'reducers/Market'
import { marketOptions } from 'constants/enums'
import { ImageWithFallback } from 'components'

const MarketIcons = ({ song, markets, dispatch }) => {
  if (!song?.market_tags?.length) {
    return null
  }

  const marketIcons = song.market_tags.map((item) => {
    for (let i = 0; i < (markets?.length ?? 0); i++) {
      if (markets[i].id === item) {
        const url = dispatch(
          MarketThunks.getMarketLogoSrc(
            markets[i].icon,
            marketOptions.darkBlue,
            marketOptions.two
          )
        )
        return (
          <ImageWithFallback
            key={`${item}`}
            className="w-5 h-5 ml-3"
            src={url}
            alt={item}
          />
        )
      }
    }
    return ''
  })

  return <>{marketIcons}</>
}

export default MarketIcons
